import React from 'react';
import { GetFeatures, Menu, prefix } from './MojaveLib';
import { Link, useLocation} from 'react-router-dom';

const Navbar = () => {

    let loc = useLocation().hash,
        main = loc.split('/'),
        features = JSON.parse(GetFeatures());

    return <aside id="leftsidebar" className="sidebar">
        <div className="container">
            <div className="row clearfix">
                <div className="col-12">
                    <div className="menu">
                        <ul className="list">
                            <li key={0} className="header">MAIN</li>
                            {Menu.map((menu, idx) => features[menu.code] !== undefined &&
                            <li key={`nav_${menu.code}`} className={`${main[1] === menu.link ? 'active open':''}`}>
                                <Link to={(prefix() == '') ? `${prefix()}/${loc}` : `/${prefix()}/${loc}`} className="menu-toggle">
                                    <i className={`zmdi zmdi-${menu.icon}`}></i><span>{menu.name}</span>
                                </Link>
                                
                                <ul className={`ml-menu mega_menu`}>
                                    {menu.submenu.map(smenu =>  features[menu.code].includes(smenu.code) &&
                                    <li key={`nav_${menu.code}${smenu.code}`}><a href={`#/${menu.link}/${smenu.link}`}>{smenu.name}</a></li>)}
                                </ul>
                            </li>)}
                            <li>&nbsp;</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </aside>;
}

export default Navbar;